module.exports = __webpack_public_path__ + "static/img/load.e1ebc35.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/load.gif
// module id = bGIW
// module chunks = 1